module.exports = __webpack_public_path__ + "img/album18_40.337cb85e.jpg";